/**
 * Answer composition — the TypeScript port of connectors/core/composer.py.
 * Every structured interaction reduces to the ONE plain-text answer a
 * keyboard participant could have typed; the server-side matchers in
 * domain/structured.py are the oracle (parity via golden fixtures).
 */

export const PNTA_TEXT = "I'd prefer not to answer";
export const NONE_TEXT = "none";

export function composeScale(value: number): string {
  return String(Math.trunc(value));
}

export function composeOption(label: string): string {
  return label.trim();
}

export function composeMultiSelect(labels: string[]): string {
  const picked = labels.map((l) => l.trim()).filter(Boolean);
  return picked.length ? picked.join(", ") : NONE_TEXT;
}

export function composeRanking(ordered: string[]): string {
  return ordered.map((l) => l.trim()).join(", ");
}

/** groupLabel → its cards (presented order); empty groups omitted. */
export function composeCardSort(assignments: Record<string, string[]>): string {
  return Object.entries(assignments)
    .filter(([, cards]) => cards.length > 0)
    .map(([group, cards]) => `${group}: ${cards.join(", ")}`)
    .join("\n");
}

/** Card-sort reply from card→group picks, cards in presented order. */
export function composeCardSortState(
  cardToGroup: Record<string, string>,
  options: string[],
  groups: string[]
): string {
  const byGroup: Record<string, string[]> = {};
  for (const g of groups) byGroup[g] = [];
  for (const card of options) {
    const group = cardToGroup[card];
    if (group !== undefined && group in byGroup) byGroup[group]!.push(card);
  }
  return composeCardSort(byGroup);
}
